import { IPhoto } from '../data_models/iphoto';
import {
  IOwnedAlbum,
  IOwnedAlbums,
  IAlbumPhotos,
  IAlbum,
} from '../data_models/ialbum';
import { ITranslator } from './itranslator';
import {
  IUpdateBulkAGAssetParams,
  IUpdateBulkAGAssetFields,
} from '../photo/iphoto_data_manager';
import {
  IUpdateBulkAGAlbumParams,
  IUpdateBulkUAAlbumParams,
} from '../album/ialbum_data_manager';
import { PhotoClusterHelper } from '../photo/photo_cluster_helper';
import { AGFavoritesManager } from '../photo/ag_favorites_manager';
import { AlbumClusterHelper } from '../album/album_cluster_helper';
import { Util } from '../../common_utils/util';
/**
 *  Responsible to translate all the Aggregator response models to the common model, which client can understand.
 */
export class AGTranslator implements ITranslator {


  static getInstance(): AGTranslator {
    if (!AGTranslator.instance) {
      AGTranslator.instance = new AGTranslator();
    }
    return AGTranslator.instance;
  }
  private static instance: AGTranslator;
  /**
   * TODO- API is not yet ready.
   * @param data
   */
   /* istanbul ignore next */
  translateSharedAlbums(data: any): any {
    
  }
  /**
   * Method will translate all favorite photos to common photo structure.
   * @param response
   * response structure:
   * {
          "entities": [{imageresponse1},{imageresponse2}]
    }
   */
  translateFavoriteAlbumPhotos(response: any): any {
    const singleAlbumResponse =  response;
    const allTranslatedPhotos: IAlbumPhotos = {
      entities: [],
      totalEntitiesCount: singleAlbumResponse.totalElements,
      resultCount: singleAlbumResponse.entities.length,
    };
    const entities = singleAlbumResponse.entities;    
    for (let i = 0; i < entities.length; i++) {
      //For favorite album, all the assets are favorite.
      entities[i].isFavorite = true;
      const trnslatedPhoto = this.translatePhoto(entities[i]);
      allTranslatedPhotos.entities.push(trnslatedPhoto);
    }
    //allTranslatedPhotos.originalResponse = response;
    return allTranslatedPhotos;
  }
  /**
   * Method will translate all photos to common photo structure.
   * @param withNoTranslator - used to keep the asset to pascal format
   * @param response
   * response structure:
   * {
      "favorites": {
          ["assetIdString", "assetIdString"]
      },
      "albumPhotos": {
          "entities": [{imageresponse1},{imageresponse2}]
      }
    }
  */
  translateOwnedAlbumPhotos(isTranslationRequired:boolean=true,response: any): any {
    //let res = {favorites: {favoriteAssetIds:[]}, assets: {response}}//Mockdata  
    const singleAlbumResponse =  response.albumPhotos;
    const allTranslatedPhotos: IAlbumPhotos = {
      entities: [],
      totalEntitiesCount: singleAlbumResponse.totalElements,
      resultCount: singleAlbumResponse.entities.length,
    };
    const entities = singleAlbumResponse.entities;
    //Get all the favorite images related to the single album.           
    const favoriteImagesInSingleAlbum = (response.favorites && response.favorites.favoriteAssetIds) ? 
      response.favorites.favoriteAssetIds : [];
    AGFavoritesManager.setFavoriteImages(favoriteImagesInSingleAlbum)
    for (let i = 0; i < entities.length; i++) {
      entities[i].isFavorite = AGFavoritesManager.isFavorite(entities[i].assetId);
      const trnslatedPhoto = isTranslationRequired?  this.translatePhoto(entities[i]) : entities[i];
      allTranslatedPhotos.entities.push(trnslatedPhoto);
    }
    //allTranslatedPhotos.originalResponse = response;
    return allTranslatedPhotos;
  }
  /**
   * TODO- PI is not yet ready.
   * @param data
   */
  translateSharedAlbumPhotos(data: object): any {
    return {};
  }
  /**
   * TODO- API is not yet ready.
   * @param photo T
   * @param albumInfo
   */
  translateSharedAlbumPhoto(photo: any, albumInfo: any): any {
    return {};
  }
  /**
   **Method to translated the cluster meta data response to get only months
   *clusters and respective albums count in each cluster, which is used for
   *creating pages and pagination in FE.
   * @param {*} response
   * @returns {*}
   * @memberof AGTranslator
   */
  prepareAlbumPagesData(clusterHelper: AlbumClusterHelper, response: any): any {

    let dateMap: { [key: string]: { collectionCount: string } } = {}
      let map = new Map();
      Object.entries(response.monthIndex).forEach(entry => {
        map.set(entry[0], entry[1]);
      });
      map.forEach((value: string, key: string) => {
          let date = key;
          dateMap[date] = { collectionCount: value }
      });
    let pages = clusterHelper.setupPages(dateMap, true);
    let firstPageData = this.translateAlbumClusters(response);
      return{
        pages: pages,
        firstPageData: firstPageData
      }
  }

  prepareCollectionListInfo(response:any):any{
    const translatedAlbums:any = [];    
    const monthyearArray: string[] = Object.keys(response.clusters);

    for (let i = 0; i < monthyearArray.length; i++) {
      const albums = response.clusters[monthyearArray[i]];
      for (let j = 0; j < albums.length; j++) {
        translatedAlbums.push(this.translateOwnedAlbum(albums[j]));
      }
    }
    return translatedAlbums;
  }
  
  /**
   * Method to prepare traslated albums response for each page
   * @param {*} response
   * @returns {*}
   * @memberof AGTranslator
   */
  translateAlbumClusters(response: any): any {
    const translatedAlbums: IOwnedAlbums = { clusters: {} };
    const entityMap = response.clusters;
    const monthyearArray: string[] = Object.keys(entityMap);

    for (let i = 0; i < monthyearArray.length; i++) {
      const albums = entityMap[monthyearArray[i]];
      const albumArray = [];
      for (let j = 0; j < albums.length; j++) {
        albumArray.push({
          album: this.translateOwnedAlbum(albums[j]),
          photoCount: albums[j].photoCount,
        });
      }
      translatedAlbums.clusters[monthyearArray[i]] = albumArray;
    }
    return translatedAlbums;
  }
  /**
   *Method to get minimal response structure required to
   *to albums in FE.
   * @param {*} entity
   * @returns {IOwnedAlbum}
   * @memberof AGTranslator
   */
  translateOwnedAlbum(entity: any): IOwnedAlbum {
    const album: IOwnedAlbum = {
      albumId: entity.album.albumId,
      url: entity.album.url,
      source: entity.album.source,
      accountId: entity.album.accountId,
      updateDate: entity.album.updateDate,
      createDate: entity.album.createDate,      
      dataCenter: entity.album.dataCenter,
      systemTags: [
        {key: "sortCode", value: entity.album.sortCode},
        {key: "customOrder", value: entity.album.customOrder}
      ],
      userTags: [{key: "caption", value: entity.album.name}],
      photoCount: entity.photoCount,
    };
    //In all albums api , we wont get firstPhoto information
    if (entity.firstPhoto) {
      album.firstAssetId = {
        assetId: entity.firstPhoto.assetId,
        ownerId: entity.firstPhoto.accountId,
        assetSource: entity.firstPhoto.assetSource,
        thumbnailEncryption: entity.firstPhoto.url,
      };
    }
    //coverting user asset album model
    if(entity.album.description){
        album.userTags.push({key: "description", value: entity.album.description})
    }
    if (entity.sharedCount > 0) {
      album.systemTags.push({key: "Share" ,value: "Private" });
    }

    return album;
  }

/**
   * Method to prepage pages date with metadata and
   * to prepare first page response
   * @param {*} response
   * @param {PhotoClusterHelper} clusterHelper
   * @returns {*}
   * @memberof AGTranslator
   * cluster response structure:
   * {
      "favorites": {
          ["assetIdString", "assetIdString"]
      },
      "assets": {
          "entities": [{imageresponse1},{imageresponse2}]
      }
    }
   */
  preparePagesData(clusterHelper: PhotoClusterHelper, response: any): any {      
      let clusterResponse = response.assets;      
      const favImagesArrayStr = (response.favorites && response.favorites.favoriteAssetIds) ? response.favorites.favoriteAssetIds: [];
      //Store the favorites images in AG favorite manager for further use in all pages.
      AGFavoritesManager.setFavoriteImages(favImagesArrayStr);
      let dateMap: { [key: string]: { assetCount: string } } = {}
      let map = new Map();
      //iterate map and set it as MAP(iterator) is returning size 0 in IE browser.
      Object.entries(clusterResponse.dateIndex).forEach(entry => {
        map.set(entry[0], entry[1]);
      });
      map.forEach((value: string, key: string) => {
          let date = key;
          dateMap[date] = { assetCount: value }
      });
      let firstPageData = this.translateClusters(clusterHelper, response);
      let pages = clusterHelper.setupPagesData(dateMap, "AGG");
      return{
        pages: pages,
        firstPageData: firstPageData
      }
  }  
  /**
   * This method will convert photo response to custom IPhoto object and prepares first assets url of the individual cluster
   * @param {*} response
   * @param {PhotoClusterHelper} clusterHelper
   * @returns {*}
   * @memberof AGTranslator
   */
  translateClusters(clusterHelper: PhotoClusterHelper, response: any): any { 
      let clusterResponse = response.assets;        
      let clusterConfig = clusterHelper.clusterConfig;
      let clusterMap: { [key: string]: { assetCount: number, assetList: Array<IPhoto>, nextUrl: string } } = {}
      let map = new Map();      
      //iterate map and set it as MAP(iterator) is returning size 0 in IE browser.
      Object.entries(clusterResponse.clusters).forEach(entry => {
        map.set(entry[0], entry[1]);
      });
      map.forEach((value: { totalElements: number, totalPages: number, entities: [{assetId:string,isFavorite:boolean}],next: string }, key: string) => {
          let date = key;
          let assetCount = value.entities.length;
          let assetList = []
          for (let photo of value.entities) {
            //Check each images against the string of favorite image ids.     
            photo.isFavorite = AGFavoritesManager.isFavorite(photo.assetId)
            assetList.push(this.translatePhoto(photo))
          }
          let nextUrl ="";
          if(assetCount < value.totalElements){ //construct next url only when minAssetPerCluster/assetCount is less that totalElements            
            value.next && (nextUrl = value.next.split("?")[1]);
            nextUrl && (nextUrl += "&timeZoneOffset="+clusterConfig.timezoneOffset);
          }
          clusterMap[date] = { 'assetCount': value.totalElements, 'assetList': assetList, nextUrl: nextUrl }
      });
      return response = {
          entities: [],
          entityMap: clusterMap,
          results: [],
          errorId: clusterResponse.errorId || null,
          resultCount: clusterResponse.resultCount || null,
          errors: clusterResponse.errors || [],
          totalEntitiesCount: clusterResponse.totalEntitiesCount || null
        };
  }

  /**
   * Method to convert Aggregate single cluster response format and photo objects to UA response format and UA photo object
   * @param {*} response
   * @param {PhotoClusterHelper} clusterHelper
   * @returns {*}
   * @memberof AGTranslator
   */
  translateClusterAssets(params:any, clusterHelper: PhotoClusterHelper, response: any): any {
      let clusterConfig = clusterHelper.clusterConfig;
      let photoList: Array<IPhoto> = []
      let entities = response.entities;
      for (let photo of entities) {
          photo.isFavorite = AGFavoritesManager.isFavorite(photo.assetId)
          photoList.push(this.translatePhoto(photo));
      }
      let nextUrl = "";
      // let queryParams = new URLSearchParams(params.nextUrl);
      // let limit: number = parseInt(queryParams.get('limit') || "0") || 0;
      // let skip: number = parseInt(queryParams.get('skip') || "0") || 0;
      //first call, response should have 10 assets, to prepare nextUrl
      //for next page, response should have 100 assets, to prepare nextUrl
      // if((skip === 0 && entities.length === clusterConfig.minAssetPerCluster) ||
      //     (skip !== 0 && entities.length === clusterConfig.viewMoreCount))
      // { 
      //     skip = skip + limit; //nextUlr skip is prevous skip + limit
      //     nextUrl = `skip=${skip}&limit=${clusterConfig.viewMoreCount}&sortCriteria=${clusterConfig.sortCriteria}
      //     &timeZoneOffset=${clusterConfig.timezoneOffset}`;
      // }      
      response.next && (nextUrl = response.next.split("?")[1]);
      nextUrl && (nextUrl += "&timeZoneOffset="+clusterConfig.timezoneOffset);

      response = {
          entities: photoList,
          entityMap: {},
          results: [],
          errorId: response.errorId || null,
          resultCount: response.resultCount || null,
          errors: response.errors || [],
          totalEntitiesCount: response.totalElements,
          nextUrl : nextUrl
        }    
      return response;
  }
    
  /**
   * Method to conevert photo response to custom IPhoto object
   * @param {*} data
   * @returns {IPhoto}
   * @memberof AGTranslator
   */
  translatePhoto(data: any): IPhoto {
    let photo =  {
        id: data.id,
        createDate: data.createDate,
        dateTaken: data.dateTaken,
        updateDate: data.updateDate,
        version: data.version || "",
        dataCenter: data.dataCenter,
        ownerAccountId: data.accountId,
        userTags: data.userTags || [
            { value: data.name, key: "userFileName" }, 
            { value: data.name, key: "caption" }, 
            { value: data.name, key: "fileName" }
        ],
        systemTags: [{ value: data.isFavorite || false, key: "isFavorite" }],
        partnerAccountId: data.partnerAccountId || "",
        currentImageInfo: data.currentImageInfo || [],
        exifTags: data.exifTags || [],
        assetType: "PICTURE",
        files: [
            {fileType : "THUMBNAIL", width : data.lrWidth || data.width, height : data.lrHeight || data.height, url : data.url, size : data.size},
            {fileType : "HIRES", width : data.width, height : data.height, url : data.url, size : data.size}
        ],
        albumIds: [],
        faces: data.faces || [],
        assetSource: data.assetSource,
        assetId : data.assetId,
        mimeType: data.mimeType,
        timeStamp:Util.getCurrentTime()
    }

    
    
    if(data.journalCore){
      photo.systemTags.push({ value: data.journalCore, key: "journalCore" })
    }
    if(data.journalDeveloper){
      photo.systemTags.push({ value: data.journalDeveloper, key: "journalDeveloper" })
    }
    
   

    return photo;
  }
  /**
   * TODO- API is ready, need to implement.
   * @param respose 
   */
  translateAlbum(respose: any): IAlbum {
      const album: IAlbum = { entities: [] }        
      if (respose && respose.album) {
          album.entities.push(this.translateOwnedAlbum(respose));
        }
      return album;        
  }
  

  /**
   * A do nothing method just to implement interface
   * @param {*} respose
   * @returns {*}
   * @memberof AGTranslator
   */
  /* istanbul ignore next */
  translateUpdatedAsset(respose: any): any {
    return respose;
  }
  /* istanbul ignore next */
  translateAssetBulkAPIAGPayLoad(data: any): IUpdateBulkAGAssetParams {
    const assetList = data.assetList;
    const assetParams: Array<IUpdateBulkAGAssetFields> = [];
    for(let i=0; i<assetList.length ; i++){
      const asset = assetList[i];
      const obj: any = {assetId: asset.assetId};
      if("name" in asset){
        obj.name = asset.name;
      }
      if('dateTaken' in asset){
        obj.dateTaken = asset.dateTaken;
      }
      assetParams.push(obj);
    }
    return {"assetList":assetParams};
  }
  /**
   *Method is to translate albums response to common response structure
   *
   * @param {{ albumIds: Array<number> }} data
   * @returns {*}
   * @memberof AGTranslator
   */
  translateBulkApiAlbumResponse(payload: any, data: { failedAlbumIds: Array<number> }): any {
    
    const response: any = { 200: [],412:[] };
    
    for (let i = 0; i < payload.albumList.length; i++) {
      const album = payload.albumList[i];
      if(data.failedAlbumIds.includes(album.albumId)){
        response[412].push({ id: album.albumId, message: 'failed' });        
      }else{
        response[200].push({ id: album.albumId, message: 'Successful' });
      }

    }
    return response;
  }
  /**
   *This method is to translate assets response to common response structure
   *
   * @param {{ photoIds: Array<number> }} data
   * @returns {*}
   * @memberof AGTranslator
   */
  translateAssetBulkApiAGResponse(data: IUpdateBulkAGAssetParams, response: any): any {
    const translatedResponse: any = { 200: [], 412: [] };
    const assetList = data.assetList;
      for (let i = 0; i < assetList.length; i++) {
          if(response.failedAssetIds.includes(assetList[i].assetId))
            translatedResponse[412].push({ id: assetList[i].id, message: 'Failure' });
          else
            translatedResponse[200].push({ id: assetList[i].id, message: 'Successful' }); 
      }
    return translatedResponse;
  }
  /**
   * Will translate the Edited Photo to normal assets format
   * If user editd mode is save as copy, we are translating and returning the photo
   *
   * @param {IPhoto} photo
   * @param {*} response
   * @returns {IPhoto}
   * @memberof AGTranslator
   */
  trnaslateAGEditedPhoto(photo: IPhoto, response: any): IPhoto{
    
    let journalKey = "journalCore";
    let thumbnailKey = 'THUMBNAIL';
    let entity = response.entities[0];
    
    //Saveascopy flow, we have two eneitires in the response
    //if edited phot is fav, so saveas copy photo is never be favourite
    //and fallowing the user assets.
    if(response.entities.length === 2){

      entity = entity.id === photo.id ? response.entities[1] : entity;
      photo = this.translatePhoto(entity);     
    
    }else{

      let thumbnailIndex = this.findIndex(photo.files, thumbnailKey, 'fileType');
      let journalIndex:number = this.findIndex(photo.systemTags, journalKey, 'key');
      
      
      let journal = {value: entity.journalCore, key : "journalCore"};
      let thumbnail =  {
        "fileType": "THUMBNAIL",
        "url": entity.url,
        "width": entity.lrWidth,
        "height": entity.lrHeight,
        "size": entity.size
      }

      photo = this.updateNewValue(photo, 'systemTags', journal, journalIndex);
      photo = this.updateNewValue(photo, 'files', thumbnail, thumbnailIndex);
    }
    
    return photo;
  
  }

  updateNewValue(photo: any, key: string, value: any, index: number){
    if(photo[key]){
      if(index !== -1){
        photo[key][index] = value;
      }else{
        photo[key].push(value);
      }
    }else{
      photo[key] = [value]
    }
    return photo;
  }

  findIndex(data: Array<any>, key: string, keyAtr: string){
    let index: number = -1;
    
    for (var i=0;i < data.length;i++){
      var tag: any = data[i];
      if(key === tag[keyAtr]){
          index = i;
          break;
      }
    }
   
    return index;
  }
  /**
   *This method is to prepare download payload to pascal api json structure.
  *
  * @param {*} data
  * @returns {*} payload
  * @memberof AGTranslator
  */
  preparePayloadForDownload(data: any): any{
    const documentIds = [];
    let payload: any;
    const allAssets = data.assetModels;
    for(let i = 0; i < allAssets.length; i++){
        const asset = allAssets[i];
        documentIds.push(asset.id)
    }
    payload = {documentIds: documentIds, zipFileName: data.zipFileName };
    return payload;
  }
  /* istanbul ignore next */
  getThumbnailUrlFromFiles(files: Array<any>): any{
  }
  /* istanbul ignore next */
  translateAlbumBulkAPIPayLoad(
    data: IUpdateBulkAGAlbumParams
  ): Array<IUpdateBulkUAAlbumParams> {
    return [];
  }
  /* istanbul ignore next */
  translateAssetBulkApiUAResponse(data:any):any{
    return [];
  }
  /* istanbul ignore next */
  translateAssetBulkAPIPayLoad(data: any):any{
    return [];
  }
  /* istanbul ignore next */
  getSourceList(status: any):any{

  };
  /* istanbul ignore next */
  transformSharedAlbumResponse(status: any, response: any): any{

  };
  /* istanbul ignore next */
  translateSharedAlbum(album: any): any{

  };
  /* istanbul ignore next */
  getAlbum(album: any, response:any): any{
  };
  /* istanbul ignore next */
  pushAlbum(arg0: any, arg1: any, arg2: any, arg3: string): any{
  };
  /* istanbul ignore next */
  prepareCombinations(arg0: string[]): any{
  }; 
  /* istanbul ignore next */
  trnaslateUAEditedPhoto(res: any): any{

  }  
}
